/**
 * Filter component for sidebar
 *
 * Properties:
 *
 *      id:             string, id for DOM
 *      zIndex:         number, optional z-index of filter select2 component to control overlapping of UI (default: 1)
 *      heading:        string, label for filter / name
 *      type:           string, type of filter (select, select2, list, datePicker)
 *      data:           array, elements must contain attribute name and value (value selection) or name and id (object selection)
 *      dataKey:        string, data attribute to identify selected items (usualy "id" for object selection or "value" for value selection)
 *      nameAttribute:  string, attribute to display in lists (e.g. username because user don't have the attribute 'name')
 *      placeholder:    string, placeholder for select and date filter
 *      selected:       any, set selection of type list or select to this value (used e.g. to reset to default value)
 *      onQueryHandle:  function, callback for query in select2 (e.g. filter list for users with name "max")
 *      onChangeHandle: function, callback executed whenever a filter value has been changed
 */

import React, { useState } from "react";
// @ts-ignore
import t from "../helpers/t";
// @ts-ignore
import { Biscuit } from "../../utils";
import Select2 from "./select2";
import de from "date-fns/locale/de"; // @todo Make dynamic
import en from "date-fns/locale/en-GB";
import fr from "date-fns/locale/fr";
// @ts-ignore
import DatePicker from "react-datepicker";
import InboomaSelectBox from "./InboomaSelectBox";

const SidebarFilter = (props: any) => {
  const [activeValue, setActiveValue] = useState(null);

  const dateLocale =
    Biscuit.get("user.lang").indexOf("de") >= 0
      ? de
      : Biscuit.get("user.lang").indexOf("fr") >= 0
        ? fr
        : en;

  const onFilterChangeHandle = (item: any) => {
    setActiveValue(item[props.dataKey]);

    props.onChangeHandle(item[props.dataKey], item[props.nameAttribute]);
  };

  const clickOutside = (e: any) => {
    e.preventDefault();
  };
  const onFilterSelectChangeHandle = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onChangeHandle(e.target.value);
    // @ts-ignore
    setActiveValue(e.target.value);
  };

  const onFilterRemoveHandle = (item: any) => {
    setActiveValue(null);
    props.onChangeHandle(null);
  };

  // get picker with same name and execute handler, show close button
  const onDatePickerChangeHandle = (date: any, name: any) => {
    for (let i = 0; i < props.data.length; i++) {
      if (props.data[i].name == name) {
        props.data[i].onChangeHandle(date);
      }
    }
  };

  // get picker with same name and execute handler, hide close button
  const onDatePickerCloseHandle = (e: any, name: string) => {
    for (let i = 0; i < props.data.length; i++) {
      if (props.data[i].name == name) {
        props.data[i].onChangeHandle(null);
      }
    }
  };

  let _activeValue = activeValue;

  if (typeof props.selected !== "undefined") {
    // set to selection (used to reset to default value or value that depends on other filter)
    _activeValue = props.selected;
  }
  let ownStyle = {};
  if (typeof props.ownStyle !== "undefined") {
    ownStyle = props.ownStyle;
  }
  const onKeyDown = (e: any) => {
    if (e.keyCode === 8) e.preventDefault();
    // @ts-ignore
    const selection = window.getSelection().toString();

    // If the user selected any text, pressing the next key will not cause maximum length to be passed
    if (selection) {
      return true;
    }

    const nextValue = e.target.value;
    const maxLength = 4;

    if (nextValue.length >= maxLength) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  return (
    <ul id={props.id} className="inb-vert-list">
      <span className="inb-list-title">{props.heading}</span>
      {props.type === "list" && (
        <>
          {props.data.map((item: any, index: any) => {
            return (
              <li
                style={{ clear: "both" }}
                className={
                  _activeValue !== null && _activeValue === item[props.dataKey] ? "active" : ""
                }
                value={item[props.dataKey]}
                key={index + "_" + item[props.dataKey]}
              >
                <div onClick={() => onFilterChangeHandle(item)}>
                  <span style={{ float: "left" }}>
                    {props.nameAttribute ? item[props.nameAttribute] : item.name}
                  </span>{" "}
                  {typeof props.summaryPending !== "undefined" && props.summaryPending && (
                    <>
                      {" "}
                      <div
                        style={{
                          float: "left",
                          maxHeight: "12px",
                          width: "12px",
                          textAlign: "center",
                          marginLeft: "10px",
                        }}
                      >
                        <img
                          className="rollingLoader colorize-black"
                          src="assets/img/rolling_loader.svg"
                        />
                      </div>{" "}
                    </>
                  )}
                </div>
                {_activeValue !== null && _activeValue == item[props.dataKey] && (
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onFilterRemoveHandle(item)}
                    title={t("unselect_filter")}
                  >
                    x
                  </a>
                )}
              </li>
            );
          })}
        </>
      )}
      {props.type === "select" && (
        <select
          className="inb-vert-list"
          style={{ marginRight: "1rem", backgroundPosition: "right 0 center" }}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onFilterSelectChangeHandle(e)}
          value={_activeValue === null ? "undefined" : _activeValue}
        >
          {props.data.map((item: any, index: string) => {
            return (
              <option value={item[props.dataKey]} key={index + "_" + item[props.dataKey]}>
                {props.nameAttribute ? item[props.nameAttribute] : item.name}
              </option>
            );
          })}
        </select>
      )}
      {props.type === "select2" && (
        <Select2
          placeholder={props.placeholder}
          data={props.data}
          ownStyle={ownStyle}
          nameAttribute={props.nameAttribute}
          selectHandle={onFilterChangeHandle}
          removeHandle={onFilterRemoveHandle}
          queryHandle={props.onQueryHandle}
          value={props.value}
          zIndex={typeof props.zIndex === "undefined" || props.zIndex === null ? 1 : props.zIndex}
        />
      )}
      {props.type === "InboomaSelect" && (
        <>
          <div id="quick-order-form__user-select-container">
            <InboomaSelectBox
              sortBy={props.sortBy}
              sortDirection={props.sortDirection}
              quickOrder={true}
              advanced={props.advanced}
              placeholder={props.placeholder}
              selectedItems={props.selectedItems}
              setSelectedItems={props.setSelectedItems}
              onSelectItem={props.onSelectHandle}
              dispatch={props.dispatch}
              container="order-vcard"
              multiSelect={props.multiSelect}
              extraStyle={typeof props.extraStyle !== "undefined" ? props.extraStyle : {}}
              onReset={props.onSelectHandle}
              model={props.model}
            />
            <div id="order-vcard" className=""></div>
          </div>
        </>
      )}
      {props.type === "datePicker" && (
        <>
          <ul style={{ listStyle: "none", marginLeft: "-10px" }}>
            {props.data.map((picker: any, index: any) => {
              // @ts-ignore
              return (
                <>
                  <li
                    className={
                      typeof picker.extraClassName !== "undefined" ? picker.extraClassName : ""
                    }
                    style={{ zIndex: "9999" }}
                  >
                    <DatePicker
                      key={"inb-sidebar-filter-" + Math.floor(Math.random() * 10000) + "-" + index}
                      className={picker.className}
                      dateFormat={picker.dateFormat}
                      selected={picker.selected}
                      onChange={(date: any) => onDatePickerChangeHandle(date, picker.name)}
                      onKeyDown={(e: any) => onKeyDown(e)}
                      placeholderText={picker.placeholder}
                      locale={dateLocale}
                      onClickOutside={(e: any) => {
                        clickOutside(e);
                      }}
                    />
                    <a
                      className={
                        picker.selected === null
                          ? "react-datepicker-close hide"
                          : "react-datepicker-close"
                      }
                      style={{ marginLeft: "-10px" }}
                      onClick={(e: any) => {
                        onDatePickerCloseHandle(e, picker.name);
                      }}
                    >
                      x
                    </a>
                  </li>
                </>
              );
            })}
          </ul>
        </>
      )}
      {props.type === "input" && (
        <input
          placeholder={props.placeholder}
          name={props.nameAttribute}
          onChange={onFilterChangeHandle}
          //   zIndex={typeof props.zIndex === 'undefined' || props.zIndex === null ? 1 : props.zIndex}
        />
      )}
    </ul>
  );
};
export default SidebarFilter;
